import { render, staticRenderFns } from "./WidgetCustomizer.vue?vue&type=template&id=89aa92fa&"
import script from "./WidgetCustomizer.vue?vue&type=script&lang=js&"
export * from "./WidgetCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCustomizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports